import { useSelector } from "react-redux";
import { getLang, getStores } from "../redux/selectors";
import { Icon } from "@iconify/react/dist/iconify.js";
import { storeId } from "../data/constants";

export const WorkingHours = () => {
  const lang = useSelector(getLang);
  const stores = useSelector(getStores);
  const currentStore = stores.find((store) => store._id === storeId);
  const workingHours =
    currentStore?.hours && Object.keys(currentStore.hours).length > 0
      ? currentStore.hours[lang] || []
      : [];

  if (!currentStore || !workingHours.length) {
    return null;
  }

  return (
    <ul className="text-sm md:text-lg font-[600] flex md:flex-row items-center justify-center gap-3 md:gap-10 px-2 py-1 w-full mx-auto bg-bluredBlack font-lato">
      <li>
        <Icon
          icon={"tabler:clock-hour-4"}
          className="hidden md:flex md:text-2xl"
        />
      </li>
      {workingHours.map((el, idx) => (
        <li key={idx} className=" whitespace-nowrap ">
          {el}
        </li>
      ))}
    </ul>
  );
};
